export default __webpack_public_path__ + "static/media/arrow.0b05ce52.svg";